import Text from "@commons/Typography/Text";
import Button from "@commons/Button";
import Heading from "@commons/Typography/Heading";
import type { GeoJsonFeature } from "@typings/components/map";
import type { SampleGeoJsonProperties } from "@services/samples/getGeoJson/type";
import { SAMPLE_TYPE_LABELS } from "@typings/entities/samples/enums";

interface SamplePopupProps {
  feature: GeoJsonFeature<SampleGeoJsonProperties>;
  onNavigate: (path: string) => void;
}

function SamplePopup({ feature, onNavigate }: SamplePopupProps) {
  if (!feature || !feature.properties) {
    return (
      <div className="p-3">
        <Text size="sm" className="text-red-500">
          Erro ao carregar dados
        </Text>
      </div>
    );
  }

  const sample = feature.properties;
  const coordinates = feature.geometry.coordinates;

  const handleNavigate = () => {
    onNavigate(`/samples/${sample.id}`);
  };

  return (
    <div className="flex flex-col gap-3 px-2 py-1 min-w-[220px]">
      <div className="flex items-center justify-between">
        <Heading size="sm">{SAMPLE_TYPE_LABELS[sample.type]}</Heading>
      </div>

      <div className="space-y-2">
        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Coordenadas:</span>{" "}
          {coordinates[1].toFixed(6)}, {coordinates[0].toFixed(6)}
        </Text>

        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Coletado por:</span>{" "}
          {sample.reporterName || "N/A"}
        </Text>

        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Espécie:</span>{" "}
          {sample.speciesName || "N/A"}
        </Text>

        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Anexos:</span>{" "}
          {sample.attachmentsCount}
        </Text>
      </div>

      <Button
        size="auto"
        customVariant="secondary"
        className="mt-2"
        onClick={handleNavigate}
      >
        Mais Detalhes
      </Button>
    </div>
  );
}

export default SamplePopup;
